import React from "react";
import { Field } from "redux-form";
import { connect } from "react-redux";
import {
  Check,
  CheckGroup,
  form,
  Form as AppForm,
  FormInput
} from "MODULES/shared/components/Forms";
import FormRow from "MODULES/shared/components/Forms/FormRow";
import { Col } from "react-bootstrap";
import {
  AUTO_FOLLOWUP,
  AUTO_FOLLOWUP_DAYS
} from "MODULES/OutgoingQuotes/constants";
import { withFieldAccessors } from "MODULES/shared/decorators/withFieldAccessors";
import { setFollowUp } from "MODULES/OutgoingQuotes/actions";
import NumberInput from "MODULES/shared/components/Forms/NumberInput/NumberInput";
import { NoteTooltip } from "MODULES/shared/components";
import validate from "./validate";

const formName = "followUpOQForm";

function Form(props) {
  return (
    <AppForm {...props}>
      <AppForm.Body>
        <FormRow>
          <Col md={6}>
            <CheckGroup
              title="Auto Follow Up"
              checkGroupStyles={{ marginBottom: 0 }}
              justified
            >
              <Field
                name={AUTO_FOLLOWUP}
                component={Check}
                label="Auto Follow Up"
                onChange={(_ev, val) => {
                  if (!val) props.setFieldValue(AUTO_FOLLOWUP_DAYS)(null);
                }}
              />
            </CheckGroup>
          </Col>
          <Col md={6}>
            <Field
              label={[
                "# of Days ",
                <NoteTooltip
                  placement="right"
                  icon="fa-info-circle"
                  color="rgba(255, 255, 255, 0.25)"
                  note={"Range: 1 to 14"}
                />
              ]}
              name={AUTO_FOLLOWUP_DAYS}
              required={props.getFieldValue(AUTO_FOLLOWUP)}
              disabled={!props.getFieldValue(AUTO_FOLLOWUP)}
              component={NumberInput}
              roundDigits={0}
              type="number"
            />
          </Col>
        </FormRow>
        <FormRow>
          <Col md={12}>
            <Field component={FormInput} name="to" label="To:" required />
          </Col>
        </FormRow>
        <FormRow>
          <Col md={12}>
            <Field component={FormInput} name="cc" label="CC:" />
          </Col>
        </FormRow>
        <FormRow>
          <Col md={12}>
            <Field component={FormInput} name="bcc" label="BCC:" />
          </Col>
        </FormRow>
      </AppForm.Body>
    </AppForm>
  );
}

export default connect(
  (_, props) => ({
    initialValues: {
      auto_followup: props.quote.auto_followup,
      auto_followup_days: props.quote.auto_followup_days,
      to: props.quote.contact.email,
      bcc: props.currentUser.email
    }
  }),
  (dispatch, ownProps) => ({
    onSubmit: data =>
      dispatch(setFollowUp(ownProps.quote.id, data, ownProps.close))
  })
)(
  form({
    form: formName,
    validate
  })(withFieldAccessors(Form))
);



// WEBPACK FOOTER //
// ./app/modules/OutgoingQuotes/Detail/AutoFollowup/Form.jsx